import * as ACTION from "../constants/billingActionTypes";

export const fetchDetails = payload => ({
    type: ACTION.FETCH_DETAILS,
    payload: payload
});

export const fetchUserCardInfo = payload => ({
    type: ACTION.FETCH_USER_CARD_INFO,
    payload: payload
});